import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_RTYPE',
    fieldMap: {
        id              : 'CIRT_ID',
        statusId        : 'CIRT_CIST_ID',
        origin          : 'CIRT_ORIGIN',
        module          : 'CIRT_MODULE',
        name            : 'CIRT_NAME',
        modifierUserId  : 'CIRT_MODIFIER',
        modificationTime: 'CIRT_MODIFICATION_TIME',
        uuid            : 'CIRT_UUID'
    }
};

export default tableDefinition;
